module.exports = __webpack_public_path__ + "img/edco_logo.c3b247d5.png";